/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */
import { Col, Row } from "react-awesome-styled-grid";
import { Box, Button } from "@nordcloud/gnui";
import { StyledLink } from "~/components";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { ResourceGroupsTable } from "~/views/resourceGroups/components/ResourceGroupsTable";

const breadcrumbsLabels = [
  { label: "Dashboard", uri: "/" },
  { label: "Resource Groups", uri: ROUTES.resourceGroups.index },
];

export function ResourceGroupsPage() {
  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Resource Groups"
            customBreadcrumbs={breadcrumbsLabels}
          >
            <StyledLink to={ROUTES.resourceGroups.create}>
              <Button icon="plus">Create Resource Group</Button>
            </StyledLink>
          </BreadcrumbsBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <ResourceGroupsTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
